/**
 * Header bottom fixed bar - aria-expanded sync for hamburger and search
 */
(function() {
	'use strict';

	function init() {
		var hamburger = document.querySelector('.header-bottom-fixed__hamburger');
		var searchBtn = document.querySelector('.bottom-search-trigger');
		var mobileSearchDrawer = document.getElementById('mobile-search-drawer');

		function syncAriaExpanded() {
			if (hamburger) {
				hamburger.setAttribute('aria-expanded', document.body.classList.contains('menu-mobile--open') ? 'true' : 'false');
			}
			if (searchBtn && mobileSearchDrawer) {
				searchBtn.setAttribute('aria-expanded', mobileSearchDrawer.classList.contains('active') ? 'true' : 'false');
			}
		}

		if (hamburger || searchBtn) {
			var observer = new MutationObserver(syncAriaExpanded);
			observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
			if (mobileSearchDrawer) {
				observer.observe(mobileSearchDrawer, { attributes: true, attributeFilter: ['class'] });
			}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();
